module.exports = __webpack_public_path__ + "img/card_230140654.ab4036f6.jpg";